(function () {
  'use strict';
  if (window.ShamelessProductSheet) {
    window.ShamelessProductSheet.init(document);
    return;
  }
  function init(scope) {
    scope.querySelectorAll('.sc-mobile-sheet-enabled').forEach(function (area) {
      if (area._scProductSheet) return;
      var root = area.closest('.shopify-section') || area;
      var summary = area.querySelector('[data-sc-product-peek]');
      var media = area.querySelector('.product-area__media');
      if (!summary || !media) return;
      var mq = window.matchMedia('(max-width: 767px)');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var atc = summary.querySelector('[data-sc-peek-atc]');
      var price = summary.querySelector('[data-sc-peek-price]');
      var detailPrice = summary.querySelector('[data-sc-detail-price]');
      var dialog = area.querySelector('[data-sc-quick-dialog]');
      if (!dialog) return;
      var quickOptions = dialog.querySelector('[data-sc-quick-options]');
      var quickPrice = dialog.querySelector('[data-sc-quick-price]');
      var quickSubmit = dialog.querySelector('[data-sc-quick-submit]');
      var quickClose = dialog.querySelector('[data-sc-quick-close]');
      var quickGroups = [], openFrame = 0, closeTimer = 0, choiceTimer = 0;
      var progress = media.querySelector('[data-sc-product-progress]');
      var viewport = media.querySelector('.theme-viewport');
      var wrapper = media.querySelector('.theme-images');
      var swiper = null, swiperTimer = 0, attempts = 0;
      var frame = 0, syncFrame = 0, nativeAtc = null;
      var choiceMade = new URLSearchParams(window.location.search).has('variant');
      var originalLabel = summary.querySelector('[data-sc-peek-label]').textContent;
      var purchaseObserver = new MutationObserver(queueSync);
      var galleryObserver = new MutationObserver(updateProgress);
      var stopped = false;

      function realButton() {
        var buttons = area.querySelectorAll('.product-purchase-form button[name="add"], button.product-atc-main[name="add"]');
        return Array.prototype.find.call(buttons, function (button) { return button.getClientRects().length; }) || buttons[0] || null;
      }
      function syncPurchase() {
        syncFrame = 0;
        if (stopped || !mq.matches) return;
        var button = realButton();
        if (!button) return;
        if (nativeAtc !== button) {
          purchaseObserver.disconnect();
          nativeAtc = button;
          purchaseObserver.observe(button, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy'] });
        }
        var source = button.querySelector('[data-product-price]') || area.querySelector('.price-area .price');
        if (source) {
          if (price.innerHTML !== source.innerHTML) price.innerHTML = source.innerHTML;
          if (detailPrice.innerHTML !== source.innerHTML) detailPrice.innerHTML = source.innerHTML;
          if (quickPrice.innerHTML !== source.innerHTML) quickPrice.innerHTML = source.innerHTML;
        }
        var busy = button.getAttribute('aria-busy') === 'true';
        atc.setAttribute('aria-busy', busy ? 'true' : 'false');
        if (summary.dataset.available === 'false') atc.setAttribute('aria-disabled', 'true');
        var label = summary.querySelector('[data-sc-peek-label]');
        if (label.textContent !== originalLabel) label.textContent = originalLabel;
        if (dialog.open) syncQuickOptions();
      }
      function queueSync() {
        if (!syncFrame && !stopped && mq.matches) syncFrame = requestAnimationFrame(syncPurchase);
      }
      function updateSheet() {
        frame = 0;
        if (stopped || !mq.matches) return;
        var button = realButton();
        var wasExpanded = area.classList.contains('sc-sheet-expanded');
        var y = Math.max(0, window.pageYOffset);
        // Fade after the first few pixels; restore only on returning to the top.
        var expanded = wasExpanded ? y > 2 : y > 8;
        if (button && !button.classList.contains('sc-product-native-atc')) button.classList.add('sc-product-native-atc');
        if (area.classList.contains('sc-sheet-expanded') !== expanded) area.classList.toggle('sc-sheet-expanded', expanded);
        detailPrice.setAttribute('aria-hidden', expanded ? 'false' : 'true');
      }
      function schedule() {
        if (mq.matches && !frame && !stopped) frame = requestAnimationFrame(updateSheet);
      }
      function revealDetails(event) {
        if (!mq.matches) return;
        if (event) event.preventDefault();
        var header = document.getElementById('site-control');
        var clearance = header ? Math.max(12, Math.min(header.getBoundingClientRect().bottom + 12, window.innerHeight * .25)) : 16;
        var top = window.pageYOffset + summary.getBoundingClientRect().top - clearance;
        window.scrollTo({ top: Math.max(0, top), behavior: reduced.matches ? 'auto' : 'smooth' });
        var controls = area.querySelectorAll('.product-detail__form__options .clickyboxes a, .product-detail__form__options button, .product-detail__form__options select');
        var first = Array.prototype.find.call(controls, function (control) {
          return !control.disabled && control.getAttribute('aria-disabled') !== 'true' && control.getClientRects().length;
        });
        if (first) first.focus({ preventScroll: true });
      }
      function buy(event) {
        if (!mq.matches) return;
        event.preventDefault();
        if (summary.dataset.available === 'false') return;
        openQuick();
      }
      function nativeOptionBox(wrapper, value) {
        var boxes = wrapper.querySelectorAll('.clickyboxes [data-value]');
        return Array.prototype.find.call(boxes, function (box) { return box.getAttribute('data-value') === value; }) || null;
      }
      function optionUnavailable(wrapper, option) {
        var box = nativeOptionBox(wrapper, option.value);
        return option.disabled || !!(box && (box.getAttribute('aria-disabled') === 'true' || box.hasAttribute('disabled') || /(?:unavailable|sold-out|soldout|disabled)/i.test(String(box.className))));
      }
      function syncQuickOptions() {
        quickGroups.forEach(function (group) {
          group.items.forEach(function (item) {
            item.button.disabled = optionUnavailable(group.wrapper, item.option);
            var selected = group.select.value === item.option.value && (group.wrapper !== choiceWrapper() || choiceMade);
            item.button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        });
        var button = realButton();
        quickSubmit.disabled = !button || button.disabled || button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-busy') === 'true' || summary.dataset.available === 'false' || (!!choiceWrapper() && !choiceMade);
      }
      function buildQuickOptions() {
        quickOptions.replaceChildren();
        quickGroups = [];
        area.querySelectorAll('.selector-wrapper[data-option-name]').forEach(function (wrapper) {
          var select = wrapper.querySelector('select');
          if (!select) return;
          var fieldset = document.createElement('fieldset');
          fieldset.className = 'sc-product-quick-dialog__group';
          var legend = document.createElement('legend');
          legend.textContent = wrapper.getAttribute('data-option-name');
          fieldset.appendChild(legend);
          var grid = document.createElement('div');
          grid.className = 'sc-product-quick-dialog__grid';
          var group = { wrapper: wrapper, select: select, items: [] };
          Array.prototype.forEach.call(select.options, function (option) {
            if (!option.value || option.value === '__placeholder__') return;
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'sc-product-quick-dialog__option';
            button.textContent = option.textContent.trim();
            button.addEventListener('click', function () {
              if (button.disabled) return;
              if (wrapper === choiceWrapper()) choiceMade = true;
              var nativeBox = nativeOptionBox(wrapper, option.value);
              if (nativeBox) nativeBox.click();
              else {
                select.value = option.value;
                select.dispatchEvent(new Event('input', { bubbles: true }));
                select.dispatchEvent(new Event('change', { bubbles: true }));
              }
              quickSubmit.disabled = true;
              window.clearTimeout(choiceTimer);
              choiceTimer = window.setTimeout(syncPurchase, 0);
            });
            group.items.push({ option: option, button: button });
            grid.appendChild(button);
          });
          fieldset.appendChild(grid);
          quickOptions.appendChild(fieldset);
          quickGroups.push(group);
        });
      }
      function openQuick() {
        if (!dialog.showModal) { revealDetails(); return; }
        window.clearTimeout(closeTimer);
        if (dialog.open) return;
        buildQuickOptions();
        dialog.showModal();
        document.documentElement.classList.add('sc-product-quick-open');
        syncPurchase();
        openFrame = requestAnimationFrame(function () {
          openFrame = 0;
          if (dialog.open) dialog.classList.add('is-visible');
        });
      }
      function closeQuick(immediate) {
        cancelAnimationFrame(openFrame); openFrame = 0;
        window.clearTimeout(closeTimer);
        if (!dialog.open) return;
        dialog.classList.remove('is-visible');
        function finish() {
          closeTimer = 0;
          dialog.close();
          document.documentElement.classList.remove('sc-product-quick-open');
        }
        if (immediate || reduced.matches) finish();
        else closeTimer = window.setTimeout(finish, 280);
      }
      function submitQuick() {
        syncQuickOptions();
        if (quickSubmit.disabled) return;
        var button = realButton();
        if (!button) return;
        quickSubmit.disabled = true;
        // Leave the top layer before the existing cart drawer opens.
        closeQuick(true);
        button.click();
      }
      function onQuickClose() { closeQuick(false); }
      function onQuickCancel(event) { event.preventDefault(); closeQuick(false); }
      function onQuickBackdrop(event) { if (event.target === dialog) closeQuick(false); }
      function choiceWrapper() {
        var wrappers = area.querySelectorAll('.selector-wrapper[data-option-name]');
        return Array.prototype.find.call(wrappers, function (wrapper) {
          return /^(size|talla|taille|größe|grösse|taglia|tamanho)$/i.test(wrapper.getAttribute('data-option-name').trim()) && wrapper.querySelector('select');
        }) || Array.prototype.find.call(wrappers, function (wrapper) { return wrapper.querySelector('select'); }) || null;
      }
      function nativeChange(event) {
        if (!mq.matches) return;
        if (event.target.closest('.selector-wrapper') === choiceWrapper() && event.isTrusted) choiceMade = true;
        queueSync();
      }
      function nativeClick(event) {
        if (!mq.matches) return;
        if (event.target.closest('.selector-wrapper [data-value]') && event.target.closest('.selector-wrapper') === choiceWrapper() && event.isTrusted) choiceMade = true;
        if (event.target.closest('.selector-wrapper')) queueSync();
      }
      function updateProgress() {
        if (stopped || !mq.matches || !progress || !wrapper) return;
        var slides = Array.prototype.filter.call(wrapper.children, function (slide) {
          return slide.classList.contains('swiper-slide') && !slide.classList.contains('swiper-slide-duplicate') && slide.style.display !== 'none';
        });
        var index = slides.findIndex(function (slide) { return slide.classList.contains('swiper-slide-active'); });
        if (index < 0 && swiper) index = Math.min(swiper.realIndex || swiper.activeIndex || 0, slides.length - 1);
        index = Math.max(0, index);
        progress.hidden = slides.length < 2;
        progress.setAttribute('aria-valuemax', String(slides.length || 1));
        progress.setAttribute('aria-valuenow', String(index + 1));
        var thumb = progress.firstElementChild;
        thumb.style.width = (100 / Math.max(1, slides.length)) + '%';
        thumb.style.transform = 'translateX(' + (index * 100) + '%)';
      }
      function bindSwiper() {
        swiperTimer = 0;
        if (stopped || !mq.matches || !viewport) return;
        var registryId = viewport.getAttribute('data-swiper-id');
        var instance = viewport.swiper || (window.theme && window.theme.swipers && window.theme.swipers[registryId]);
        if (instance && !instance.destroyed && typeof instance.on === 'function') {
          swiper = instance;
          ['slideChange', 'update', 'resize', 'observerUpdate'].forEach(function (name) { swiper.on(name, updateProgress); });
          updateProgress();
        } else if (++attempts < 25) {
          swiperTimer = window.setTimeout(bindSwiper, 200);
        }
      }
      function stopGallery() {
        window.clearTimeout(swiperTimer);
        if (swiper && !swiper.destroyed && typeof swiper.off === 'function') {
          ['slideChange', 'update', 'resize', 'observerUpdate'].forEach(function (name) { swiper.off(name, updateProgress); });
        }
        swiper = null;
        galleryObserver.disconnect();
      }
      function mediaChange() {
        closeQuick(true);
        stopGallery();
        purchaseObserver.disconnect(); nativeAtc = null;
        if (mq.matches) {
          attempts = 0;
          if (wrapper && progress) galleryObserver.observe(wrapper, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style'] });
          bindSwiper(); syncPurchase(); updateSheet(); updateProgress();
        } else {
          area.classList.remove('sc-sheet-expanded');
          area.querySelectorAll('.sc-product-native-atc').forEach(function (button) { button.classList.remove('sc-product-native-atc'); });
        }
      }
      function destroy() {
        stopped = true;
        closeQuick(true);
        window.clearTimeout(choiceTimer);
        stopGallery(); purchaseObserver.disconnect();
        cancelAnimationFrame(frame); cancelAnimationFrame(syncFrame);
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
        root.removeEventListener('change', nativeChange, true);
        root.removeEventListener('click', nativeClick, true);
        atc.removeEventListener('click', buy);
        quickClose.removeEventListener('click', onQuickClose);
        quickSubmit.removeEventListener('click', submitQuick);
        dialog.removeEventListener('cancel', onQuickCancel);
        dialog.removeEventListener('click', onQuickBackdrop);
        summary.querySelector('[data-sc-reveal]').removeEventListener('click', revealDetails);
        if (mq.removeEventListener) mq.removeEventListener('change', mediaChange);
        else mq.removeListener(mediaChange);
        delete area._scProductSheet;
      }
      area._scProductSheet = { destroy: destroy };
      atc.addEventListener('click', buy);
      quickClose.addEventListener('click', onQuickClose);
      quickSubmit.addEventListener('click', submitQuick);
      dialog.addEventListener('cancel', onQuickCancel);
      dialog.addEventListener('click', onQuickBackdrop);
      summary.querySelector('[data-sc-reveal]').addEventListener('click', revealDetails);
      root.addEventListener('change', nativeChange, true);
      root.addEventListener('click', nativeClick, true);
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      if (mq.addEventListener) mq.addEventListener('change', mediaChange);
      else mq.addListener(mediaChange);
      mediaChange();
    });
  }
  window.ShamelessProductSheet = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.sc-mobile-sheet-enabled').forEach(function (area) {
      if (area._scProductSheet) area._scProductSheet.destroy();
    });
  });
})();